module.exports = __webpack_public_path__ + "img/okr.6e7501d0.svg";